import { Icon } from '~/components/Icon'

export default function LoginServerError({ message }: { message: string }): React.ReactElement | null {
  if (!message) {
    return null
  }

  return (
    <div
      className="mx-auto py-2 px-4 flex items-center border border-gray-placeholder rounded"
      data-test-id="login-server-error"
    >
      <Icon className="text-red mr-2" name="error_outline" />
      {message}
    </div>
  )
}
